import { playbackClass } from "@healthos/shared";
export function feedbackSubjectForContentItem(item, surface, metadata = {}) {
    return {
        about: `${item.kind}: ${item.title}`,
        subjectId: item.id,
        subjectType: subjectTypeForContentItemKind(item.kind),
        surface,
        metadata: {
            kind: item.kind,
            ...metadata,
        },
    };
}
export function feedbackSubjectForBrief(brief, surface) {
    return {
        about: `Weekly Brief: ${brief.title ?? brief.briefDate}`,
        subjectId: brief.id,
        subjectType: "brief",
        surface,
        metadata: {
            briefDate: brief.briefDate,
        },
    };
}
export function feedbackSubjectForPlanDay({ planId, dayNumber, label, state, surface = "web.plan-week", }) {
    return {
        about: `Plan day ${dayNumber}: ${label}`,
        subjectId: `${planId ?? "no-active-plan"}:day:${dayNumber}`,
        subjectType: "plan_item",
        surface,
        metadata: { dayNumber, state },
    };
}
export function feedbackSubjectForNextAction(action, surface) {
    return {
        about: `${action.kind}: ${action.title}`,
        subjectId: action.actionId ?? action.contentId ?? action.title,
        subjectType: subjectTypeForNextActionKind(action.kind),
        surface,
        metadata: {
            kind: action.kind,
            category: action.category ?? null,
            tier: action.tier ?? null,
        },
    };
}
/** @deprecated Use feedbackSubjectForNextAction */
export const feedbackSubjectForAction = feedbackSubjectForNextAction;
function subjectTypeForContentItemKind(kind) {
    if (kind === "Article")
        return "article";
    if (kind === "Story")
        return "article";
    if (kind === "RoleModel")
        return "article";
    if (kind === "Recipe")
        return "recipe";
    if (playbackClass(kind) === "video")
        return "reset";
    return "plan_item";
}
function subjectTypeForNextActionKind(kind) {
    if (kind === "story")
        return "article";
    if (kind === "recipe")
        return "recipe";
    if (kind === "reset")
        return "reset";
    if (kind === "guide")
        return "reset";
    return "plan_item";
}
//# sourceMappingURL=feedback-subjects.js.map